<template>
  <div class="el-tabs__inner">
    <draggable
      :list="fields"
      :clone="clone"
      class="row ma-0 pa-2 justify-center"
      :group="{ name: 'forms', pull: 'clone', put: false }"
      :sort="false"
      :move="onMove"
      @end="onEnd"
      @start="onStart"
    >
      <template v-for="(field, index) in fields">
        <span
          ref="FormChallenge"
          :key="index"
          v-if="field.type == 'Form'"
          class="badge button__sidebar v-btn v-btn--contained theme--light v-size--default font-weight-bold ma-2 grabbing"
          >{{ $t(field.text) }}</span
        >
      </template>
    </draggable>
  </div>
</template>


<script>
import { FormBuilder } from "@/components/form_elements_sentences/formbuilder.js";
export default {
  name: "Elements",
  components: FormBuilder.$options.components,
  data() {
    return {
      fields: FormBuilder.$data.fields,
    };
  },
  methods: {
    clone(field) {
      console.log("---clone", field);
      return this._.cloneDeep(field);
    },
    cloneElement(index, field, form, fieldsDefaultID) {
      var cloned = this._.cloneDeep(field); // clone deep lodash
      cloned.id = `${fieldsDefaultID}`;
      form.splice(index + 1, 0, cloned);
      this.editElementProperties(cloned);
    },

    editElementProperties(field) {
      this.$store.activeFieldExpression = field;
      this.$store.activeTabForFieldsExpression = "properties";
    },
    onMove({ relatedContext, draggedContext }) {
      const relatedElement = relatedContext.element;
      const draggedElement = draggedContext.element;
      const { id } = relatedContext.component.$attrs;
      if (id == "fieldsExpression" && draggedElement.key == "FormSentence") {
        document.documentElement.classList.add("draggable-cursor--no-drop");
        return false;
      } else {
        document.documentElement.classList.remove("draggable-cursor--no-drop");
        document.documentElement.classList.add("draggable-cursor");
        return (
          (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed
        );
      }
    },
    // Sets default page cursor as grabbing
    onStart() {
      document.documentElement.classList.remove("draggable-cursor--no-drop");
      document.documentElement.classList.add("draggable-cursor");
    },
    // Restores default page cursor
    onEnd() {
      document.documentElement.classList.remove("draggable-cursor");
      document.documentElement.classList.remove("draggable-cursor--no-drop");
    },
  },
};
</script>

<style lang="scss" scoped>
.button__sidebar {
  width: 100%;
  //   margin-bottom: 5px;

  .is-disabled & {
    opacity: 0.4;
  }
}

// Display this ghost in <main> only
.sortable__ghost {
  position: relative;
  max-width: 140px;
  margin-top: -10px;
  [type="button"] {
    display: none;
  }
  &:before {
    background-color: #ecf5ff;
    position: absolute;
    font-size: 10px;
    border-radius: 10px;
    transform: translateX(-50%);
  }
}
</style>
